var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnlyLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "464px",
    height: "434px",
    viewBox: "0 0 464 434",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo finaal copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-finaal-copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3rd-copy-3",
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 9.425,
    x: 19.2125,
    y: 21.3769407,
    width: 425.575,
    height: 391.246119,
    rx: 29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.402564,56.5763292 L56.3615133,215.578506 C55.1790578,216.658785 55.0962278,218.493095 56.1765075,219.67555 C56.2368798,219.741633 56.3002791,219.804885 56.3665019,219.865103 L229.674774,377.45932 C230.779239,378.463642 232.465703,378.465426 233.572291,377.463442 L407.62877,219.860303 C408.816013,218.785288 408.906993,216.951365 407.831978,215.764121 C407.771843,215.697709 407.708664,215.63412 407.642642,215.573557 L234.318943,56.5803026 C233.211654,55.5645646 231.511912,55.5628401 230.402564,56.5763292 Z",
    id: "Path-2",
    stroke: "#FFFFFF",
    strokeWidth: 9.425
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 440.4375,
    cy: 23.5475793,
    rx: 23.5625,
    ry: 23.5475793
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 232,
    cy: 20.2871452,
    rx: 16.3125,
    ry: 16.3021703
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 232,
    cy: 413.712855,
    rx: 16.3125,
    ry: 16.3021703
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 444.7875,
    cy: 217,
    rx: 16.3125,
    ry: 16.3021703
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 19.2125,
    cy: 217,
    rx: 16.3125,
    ry: 16.3021703
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 23.5625,
    cy: 23.5475793,
    rx: 23.5625,
    ry: 23.5475793
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 23.5625,
    cy: 410.452421,
    rx: 23.5625,
    ry: 23.5475793
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 440.4375,
    cy: 409.452421,
    rx: 23.5625,
    ry: 23.5475793
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-9",
    stroke: "#FFFFFF",
    strokeWidth: 0.725,
    fill: "#FFFFFF",
    points: "232.350193 68.5415693 306.089675 135.927496 232 203.313422 157.601659 135.863929"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-9",
    stroke: "#FFFFFF",
    strokeWidth: 0.725,
    fill: "#FFFFFF",
    points: "232 230.898608 305.630771 298.966275 231.631657 366.010729 157.91791 298.716312"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-9",
    stroke: "#FFFFFF",
    strokeWidth: 0.725,
    fill: "#FFFFFF",
    points: "320.545036 149.051834 395.23754 217.651063 320.127543 285.887161 246.467571 217.36227"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-9",
    stroke: "#FFFFFF",
    strokeWidth: 0.725,
    fill: "#FFFFFF",
    points: "143.776761 148.937797 217.655087 217.254486 143.228131 285.734571 68.0609404 217.866217"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.3625,
    y1: 377.129054,
    x2: 405.6375,
    y2: 57.6375,
    id: "Line",
    stroke: "#FFFFFF",
    strokeWidth: 9.425,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 405.6375,
    y1: 377.3625,
    x2: 58.3625,
    y2: 57.6375,
    id: "Line",
    stroke: "#FFFFFF",
    strokeWidth: 9.425,
    strokeLinecap: "round",
    transform: "translate(232, 217.5) rotate(0.2652) translate(-232, -217.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlyLogoWhite);
export default __webpack_public_path__ + "static/media/only_logo_white.a5aaf330e3b2ba08d753d6968625720e.svg";
export { ForwardRef as ReactComponent };